import React from "react";
import ProductItem from "./ProductItem";
import { useSelector } from "react-redux";

const ProductContainer = () => {
  const products = useSelector((state) => state.productItems);
  
  return (
    <div className="productContainer" id="lws-productContainer">
      {products.length === 0 ? (
        <p className="text-lg font-bold text-red-500">No Product Found</p>
      ) : (
        products.map((product) => (
          <ProductItem key={product?.id} product={product} />
        ))
      )}
    </div>
  );
};

export default ProductContainer;
